
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as indexUQgd4u2ejfvbmKpyS7jyezfd02AzO9DGvMldnZ6fwQUMeta } from "/app/app/pages/support/index.vue?macro=true";
import { default as _91slug_93QdzfBPuGX156r0KMm_AhYJhAq0Eyx7XRotfBNCGUJlwMeta } from "/app/app/pages/support/[slug].vue?macro=true";
import { default as thank_45youj6FaWAeQSO4vzWSPnBvybzS57SXntwzRcU5oJax6kOsMeta } from "/app/app/pages/checkout/thank-you.vue?macro=true";
import { default as _91slug_93qCF0uJ_3_i_nnhOZwrxHrf9T_w3jWkBb99ef9wo37J8Meta } from "/app/app/pages/collections/[slug].vue?macro=true";
import { default as contact_45usVwBDqE8sRNgE1i_yqxZoPkCNiATvE_DLpcuGF9xlZMkMeta } from "/app/app/pages/(marketing)/contact-us.vue?macro=true";
import { default as philosophyRHDGBlw76SXNbq_iuxDieQW5CBgtTgiG6_B0v9RJOI0Meta } from "/app/app/pages/(marketing)/philosophy.vue?macro=true";
import { default as order_45detailsJG_iO5aOaK80F8gqg1Wn8pmO3nxuzsu_VtohvcV1qm4Meta } from "/app/app/pages/checkout/order-details.vue?macro=true";
import { default as _91product_93_45_91variation_93URcNYhy6GoCeohR_tLPhHzGdL9KOgXdO5YDIh_bbh3YMeta } from "/app/app/pages/collections/[...slug]/[product]-[variation].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "support___en",
    path: "/support",
    meta: indexUQgd4u2ejfvbmKpyS7jyezfd02AzO9DGvMldnZ6fwQUMeta || {},
    component: () => import("/app/app/pages/support/index.vue")
  },
  {
    name: "support___de",
    path: "/de/support",
    meta: indexUQgd4u2ejfvbmKpyS7jyezfd02AzO9DGvMldnZ6fwQUMeta || {},
    component: () => import("/app/app/pages/support/index.vue")
  },
  {
    name: "support___fr",
    path: "/fr/support",
    meta: indexUQgd4u2ejfvbmKpyS7jyezfd02AzO9DGvMldnZ6fwQUMeta || {},
    component: () => import("/app/app/pages/support/index.vue")
  },
  {
    name: "support___it",
    path: "/it/support",
    meta: indexUQgd4u2ejfvbmKpyS7jyezfd02AzO9DGvMldnZ6fwQUMeta || {},
    component: () => import("/app/app/pages/support/index.vue")
  },
  {
    name: "support-slug___en",
    path: "/support/:slug()",
    meta: _91slug_93QdzfBPuGX156r0KMm_AhYJhAq0Eyx7XRotfBNCGUJlwMeta || {},
    component: () => import("/app/app/pages/support/[slug].vue")
  },
  {
    name: "support-slug___de",
    path: "/de/support/:slug()",
    meta: _91slug_93QdzfBPuGX156r0KMm_AhYJhAq0Eyx7XRotfBNCGUJlwMeta || {},
    component: () => import("/app/app/pages/support/[slug].vue")
  },
  {
    name: "support-slug___fr",
    path: "/fr/support/:slug()",
    meta: _91slug_93QdzfBPuGX156r0KMm_AhYJhAq0Eyx7XRotfBNCGUJlwMeta || {},
    component: () => import("/app/app/pages/support/[slug].vue")
  },
  {
    name: "support-slug___it",
    path: "/it/support/:slug()",
    meta: _91slug_93QdzfBPuGX156r0KMm_AhYJhAq0Eyx7XRotfBNCGUJlwMeta || {},
    component: () => import("/app/app/pages/support/[slug].vue")
  },
  {
    name: "checkout-thank-you___en",
    path: "/checkout/thank-you",
    meta: thank_45youj6FaWAeQSO4vzWSPnBvybzS57SXntwzRcU5oJax6kOsMeta || {},
    component: () => import("/app/app/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___de",
    path: "/de/checkout/thank-you",
    meta: thank_45youj6FaWAeQSO4vzWSPnBvybzS57SXntwzRcU5oJax6kOsMeta || {},
    component: () => import("/app/app/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___fr",
    path: "/fr/checkout/thank-you",
    meta: thank_45youj6FaWAeQSO4vzWSPnBvybzS57SXntwzRcU5oJax6kOsMeta || {},
    component: () => import("/app/app/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___it",
    path: "/it/checkout/thank-you",
    meta: thank_45youj6FaWAeQSO4vzWSPnBvybzS57SXntwzRcU5oJax6kOsMeta || {},
    component: () => import("/app/app/pages/checkout/thank-you.vue")
  },
  {
    name: "collections-slug___en",
    path: "/collections/:slug()",
    component: () => import("/app/app/pages/collections/[slug].vue")
  },
  {
    name: "collections-slug___de",
    path: "/de/collections/:slug()",
    component: () => import("/app/app/pages/collections/[slug].vue")
  },
  {
    name: "collections-slug___fr",
    path: "/fr/collections/:slug()",
    component: () => import("/app/app/pages/collections/[slug].vue")
  },
  {
    name: "collections-slug___it",
    path: "/it/collections/:slug()",
    component: () => import("/app/app/pages/collections/[slug].vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/app/app/pages/(marketing)/contact-us.vue")
  },
  {
    name: "contact-us___de",
    path: "/de/contact-us",
    component: () => import("/app/app/pages/(marketing)/contact-us.vue")
  },
  {
    name: "contact-us___fr",
    path: "/fr/contact-us",
    component: () => import("/app/app/pages/(marketing)/contact-us.vue")
  },
  {
    name: "contact-us___it",
    path: "/it/contact-us",
    component: () => import("/app/app/pages/(marketing)/contact-us.vue")
  },
  {
    name: "philosophy___en",
    path: "/philosophy",
    component: () => import("/app/app/pages/(marketing)/philosophy.vue")
  },
  {
    name: "philosophy___de",
    path: "/de/philosophy",
    component: () => import("/app/app/pages/(marketing)/philosophy.vue")
  },
  {
    name: "philosophy___fr",
    path: "/fr/philosophy",
    component: () => import("/app/app/pages/(marketing)/philosophy.vue")
  },
  {
    name: "philosophy___it",
    path: "/it/philosophy",
    component: () => import("/app/app/pages/(marketing)/philosophy.vue")
  },
  {
    name: "checkout-order-details___en",
    path: "/checkout/order-details",
    meta: order_45detailsJG_iO5aOaK80F8gqg1Wn8pmO3nxuzsu_VtohvcV1qm4Meta || {},
    component: () => import("/app/app/pages/checkout/order-details.vue")
  },
  {
    name: "checkout-order-details___de",
    path: "/de/checkout/order-details",
    meta: order_45detailsJG_iO5aOaK80F8gqg1Wn8pmO3nxuzsu_VtohvcV1qm4Meta || {},
    component: () => import("/app/app/pages/checkout/order-details.vue")
  },
  {
    name: "checkout-order-details___fr",
    path: "/fr/checkout/order-details",
    meta: order_45detailsJG_iO5aOaK80F8gqg1Wn8pmO3nxuzsu_VtohvcV1qm4Meta || {},
    component: () => import("/app/app/pages/checkout/order-details.vue")
  },
  {
    name: "checkout-order-details___it",
    path: "/it/checkout/order-details",
    meta: order_45detailsJG_iO5aOaK80F8gqg1Wn8pmO3nxuzsu_VtohvcV1qm4Meta || {},
    component: () => import("/app/app/pages/checkout/order-details.vue")
  },
  {
    name: "collections-slug-product-variation___en",
    path: "/collections/:slug([^/]*)*/:product()-:variation()",
    component: () => import("/app/app/pages/collections/[...slug]/[product]-[variation].vue")
  },
  {
    name: "collections-slug-product-variation___de",
    path: "/de/collections/:slug([^/]*)*/:product()-:variation()",
    component: () => import("/app/app/pages/collections/[...slug]/[product]-[variation].vue")
  },
  {
    name: "collections-slug-product-variation___fr",
    path: "/fr/collections/:slug([^/]*)*/:product()-:variation()",
    component: () => import("/app/app/pages/collections/[...slug]/[product]-[variation].vue")
  },
  {
    name: "collections-slug-product-variation___it",
    path: "/it/collections/:slug([^/]*)*/:product()-:variation()",
    component: () => import("/app/app/pages/collections/[...slug]/[product]-[variation].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/about-us",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/about-us",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/about-us",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/about-us",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]